import {create} from 'zustand';

const useUserStore = create((set) => ({
    user: localStorage.getItem('user') || [],
    authenticated: false,
    setUser: (data) => {
        localStorage.setItem("user", data.userData.email)
        localStorage.setItem("userId", data.userData.id)
        localStorage.setItem("authenticated", true)
        localStorage.setItem("token", data.token)
        set({
            user: data.userData.email,
            authenticated: true
        })
    },
    checkUserData: () => {
        if(localStorage.getItem("authenticated")){
            set({
                user: localStorage.getItem("user"),
                authenticated: true
            })
        } else{

        }
    },
    logout: () => {
        localStorage.removeItem("user")
        localStorage.removeItem("authenticated")
        localStorage.removeItem("token")
        set({
            user: "",
            authenticated: false
        })
    }
}))

export default useUserStore;